import { ChangeDetectionStrategy, Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IScimUserDetail } from '@shared/models/scim-admin';
import { Subject } from 'rxjs';

@Component({
	selector: 'app-scim-user-detail-dialog',
	standalone: false,
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './scim-user-detail-dialog.component.html',
})
export class ScimUserDetailDialogComponent implements OnDestroy {
	private destroy$ = new Subject<void>();

	constructor(
		@Inject(MAT_DIALOG_DATA) public user: IScimUserDetail,
		public dialogRef: MatDialogRef<ScimUserDetailDialogComponent>,
	) {}

	onClose(): void {
		this.dialogRef.close();
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}
}
